import React from 'react';

import { Flex, Icon, Link, Text } from '@chakra-ui/react';

import { AppstoreIcon, GooglePlayIcon } from '../../../Icons';
import { EColor } from '../../../Theme';
import { getFanaticsUrls } from '../../utils/fanaticsUrls';

export function FooterAppLinks() {
  const { app } = getFanaticsUrls();
  const { appStoreLink, googlePlayLink } = app;

  return (
    <Flex
      flexDirection="column"
      gap={{ base: '8px', sm: '16px' }}
      px={{ base: '30px', sm: '16px' }}
      py="32px"
    >
      <Text fontSize="18px" fontWeight="700" sx={{ textWrap: 'nowrap' }}>
        Get the App
      </Text>

      <Flex
        flexDirection={{ base: 'row', xl: 'column' }}
        flexWrap="wrap"
        gap="8px"
      >
        <Link href={appStoreLink} target="_blank">
          <Icon
            as={AppstoreIcon}
            color={EColor.Neutral75}
            height="40px"
            width="120px"
          />
        </Link>

        <Link href={googlePlayLink} target="_blank">
          <Icon
            as={GooglePlayIcon}
            color={EColor.Neutral75}
            height="40px"
            width="135px"
          />
        </Link>
      </Flex>
    </Flex>
  );
}
